import React, { useState, useEffect } from 'react';
import { AutoComplete } from 'antd';
import { debounce } from 'lodash';
import { getLocationSuggestions } from './findLocation';

const LocationSelect = ({ value, onChange, placeholder = "Enter a location" }) => {
    const [options, setOptions] = useState([]);
    const [displayValue, setDisplayValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Initialize display value based on the provided value
        if (value) {
            if (typeof value === 'object' && value.name) {
                setDisplayValue(value.name);
            } else if (typeof value === 'string') {
                setDisplayValue(value);
            }
        } else {
            setDisplayValue('');
        }
    }, [value]);

    const handleSearch = debounce((searchText) => {
        if (!searchText) {
            setOptions([]);
            return;
        }

        setLoading(true);
        try {
            const locations = getLocationSuggestions(searchText);
            const formattedOptions = locations.map(location => ({
                value: location.locationId,
                label: location.value,
                locationId: location.locationId
            }));
            setOptions(formattedOptions);
        } catch (error) {
            console.error('Error searching locations:', error);
            setOptions([]);
        }
        setLoading(false);
    }, 500);

    const handleChange = (selectedValue, option) => {
        setDisplayValue(option?.label || selectedValue);

        if (option?.locationId) {
            // Pass only the locationId as a string
            onChange(option.locationId);
        } else if (selectedValue) {
            // If no option selected but there's a value, pass the raw value
            onChange(selectedValue);
        } else {
            // Clear the selection
            onChange(undefined);
        }
    };

    return (
        <AutoComplete
            value={displayValue}
            options={options}
            onSearch={handleSearch}
            onChange={handleChange}
            placeholder={placeholder}
            loading={loading}
            allowClear
            style={{ width: '100%' }}
        />
    );
};

export default LocationSelect; 